import { i18n } from 'i18next';
import { useTranslation } from 'react-i18next';
import english from './locales/en.json';
import { Language } from './LocalizationEnum';

export type TranslationsType = typeof english;

export type TranslationKey = Leaves<TranslationsType>;

type PFunction = <TPartial extends TranslationsNodes, TRest extends Leaves<PickTypeByPath<TranslationsType, TPartial>> & string>(
  prefix: TPartial
) => (rest: TRest) => `${TPartial}.${TRest}`;

type TranslationsNodes = Nodes<TranslationsType>;

interface ITranslator {
  i18n: i18n;
  t: TFunction;
  prefix: PFunction;
  language: Language;
}

export type TFunction = (path: TranslationKey, variables?: Record<string, string | number | null>) => string;

const prefix: PFunction = (prefix) => (rest) => `${prefix}.${rest}`;

export function useTranslator(): ITranslator {
  const { t, i18n } = useTranslation();

  const translate = (path: TranslationKey, variables?: Record<string, string | number | null>): string => t(path, { ...variables });

  return {
    t: translate,
    prefix,
    i18n,
    language: i18n.language as Language,
  };
}
